import React from "react";

import styled from "@mui/material/styles/styled";

import { Row, StackProps } from "@rui/Stack";

export const LIST_GAP_PX = 4;
const SQUARE_SIZE_PX = 20; // includes the 1px of padding on each side
const NUM_COLUMNS = 4;

const OuterColorSquare = styled<React.FunctionComponent<StackProps>>(
  (props) => <Row variant="center" {...props} />
)(({ onClick, theme }) => ({
  height: `${SQUARE_SIZE_PX}px`,
  width: `${SQUARE_SIZE_PX}px`,
  flexShrink: 0,
  borderRadius: "3px",
  border: "1px solid transparent",
  padding: "1px",
  "&:hover": {
    cursor: onClick ? "pointer" : "default",
    borderColor: onClick ? theme.palette.shades.neutral[100] : undefined,
  },
}));

const InnerColorSquare = styled<React.FunctionComponent<StackProps>>(
  (props) => <Row variant="center" {...props} />
)(({ theme }) => ({
  height: "100%",
  width: "100%",
  borderRadius: "2px",
  fontSize: "0.75rem",
  fontWeight: 500,
  fontFamily: theme.typography.fontFamilySecondary,
  "& .MuiSvgIcon-root": {
    fontSize: "0.75rem",
  },
}));

export const ColorSquare = ({ children, sx, ...props }: StackProps) => (
  <OuterColorSquare {...props}>
    <InnerColorSquare sx={sx}>{children}</InnerColorSquare>
  </OuterColorSquare>
);

export const ColorList = styled(Row)({
  borderRadius: "2px",
  padding: `${LIST_GAP_PX}px`,
  flexWrap: "wrap",
  maxWidth: `${
    NUM_COLUMNS * SQUARE_SIZE_PX + LIST_GAP_PX * (NUM_COLUMNS + 1)
  }px`,
  rowGap: `${LIST_GAP_PX}px`,
  columnGap: `${LIST_GAP_PX}px`,
});
